<template>
  <div class="sd-subscription-page sd-portal-subscription">
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        Dashboard
      </router-link>
      <router-link to="/school/subscription" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i> Subscription
      </router-link>
      <span class="text-white"> <i class="fa fa-ellipsis-v px-2"></i>Portal Subscription</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <div class="sd-page-heading">
        <span class="sd-page-eyebrow">SUBSCRIPTION MANAGEMENT</span>
        <h1>Manage subscriptions</h1>
        <p>Choose a term, select the services and students, then review your subscription before payment.</p>
      </div>
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <modal :show.sync="modals.PaymentModal" modal-classes="modal-dialog-centered modal-md">
            <div class="card bg-secondary border-0 mb-0">
              <div class="card-body">
                <PageSpinner :onloader="onloader" />
                <div class="confirmation-container subscription-confirm">
                  <span class="sd-page-eyebrow">PAYMENT REVIEW</span>
                  <h2>Confirm your subscription</h2>

                  <section class="details-summary">
                    <h3>{{ PaymentDetails }}</h3>
                    <p>By clicking "Subscribe," you authorize us to charge your selected payment method for the amount
                      shown above </p>
                  </section>
                </div>
              </div>
            </div>
            <template slot="footer">
              <base-button type="default" @click="modals.PaymentModal = false">Cancel
              </base-button>
              <base-button type="success" @click.prevent="MakePayment()"> Subscribe Now & Pay
              </base-button>
            </template>
          </modal>
          <div>
            <div class="sd-subscription-toolbar justify-content-end form-inline my-3">
              <label class="sd-field-label" for="registered-term">Registered term</label>
              <select id="registered-term" v-model="SessionIdval" class="form-control">
                <option value="0">- Select Registered Term -</option>
                <option v-for="item in Sessionitems" :key="item.registeredTermId" v-bind:value="item.registeredTermId">
                  {{ item.schSession }} - {{ item.schTerm }}
                </option>
              </select>
              <label class="cb cb-square ml-3">
                <input type="checkbox" v-model="cbtSubscribedVal">
                <span class="cb-box" aria-hidden="true"><span class="dot"></span></span>
                <small>CBT Subscription</small>
              </label>
              <label class="cb cb-square ml-3">
                <input type="checkbox" v-model="reportSubscribedVal" disabled>
                <span class="cb-box" aria-hidden="true"><span class="dot"></span></span>
                <small>Report Card Subscription</small>
              </label>
            </div>
            <div class="card sd-selection-panel" v-if="SessionIdval">
              <div class="card-body">
                <h2 class="sd-section-title">Select classes</h2>
                <p class="sd-section-copy">Choose the classes whose students should be included.</p>
                <div class="row">
                  <div class="col" v-for="item in SchoolClasses" :key="item.Id">
                    <label class="cb cb-square">
                      <input type="checkbox" :value="item.Id" v-model="selectedClasses"
                        @change="GetSchoolStudentByClasses">
                      <span class="cb-box" aria-hidden="true"><span class="dot"></span></span>
                      <small>{{ item.Sch_Class }}</small>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="SchoolStudents">
              <div class="col-md-4" v-for="item in SchoolStudents" :key="item.studentId">
                <div class="card sd-student-card text-center m-2">
                  <div class="card-body">
                    <img v-if="item.passport" :src="item.passport" class="rounded" alt="" height="50" />
                    <img v-else src="img/brand/loguser.png" class="rounded" alt="" height="50" />
                    <h5 class="text-white"><small>{{ item.studentName }}</small> </h5>
                    <h6 class="text-white"> <small>{{ item.admNo }} | {{ item.sch_Class }} </small>
                    </h6>
                    <div>
                      <button class="btn btn-danger btn-sm my-2" v-on:click="deleteStudent(item.studentId)">
                        <i class="fa fa-times"></i> Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3 text-center" v-if="SchoolStudents && SchoolStudents.length > 0">
              <button type="button" class="btn btn-primary sd-primary-action" @click="submitSelectedStudents">
                <i class="fa fa-check"></i> Submit Selected Students ({{ SchoolStudents.length }})
              </button>
            </div>
          </div>
        </card>
      </div>
      <!-- End charts-->
    </div>
  </div>
</template>

<script>
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
  name: "reportcarsub",
  mixins: [Alert, CheckStaffUser],
  components: {
    PageSpinner
  },
  data() {
    return {
      accessDetails: null,
      SessionIdval: 0,
      PaymentDetails: "",
      PaymentLink: "",
      cbtSubscribedVal: false,
      reportSubscribedVal: true,
      Sessionitems: null,
      selectedClasses: [],
      SchoolStudents: null,
      paymentItem: null,
      SchoolClasses: null,
      process: "N",
      onloader: "none",
      modals: {
        PaymentModal: false
      }
    };
  },
  methods: {
    deleteStudent(studentId) {
      this.SchoolStudents = this.SchoolStudents.filter(s => s.studentId !== studentId);
      this.SchoolStudents = this.SchoolStudents.filter(id => id !== studentId);
    },
    GetSchoolStudentByClasses() {
      this.onloader = "flex";
      let ClassIds = this.selectedClasses.join(", ");
      this.$store
        .dispatch("PortalStudent/GetSchoolStudentByClasses", ClassIds)
        .then((resp) => {
          this.SchoolStudents = resp.data;
        })
        .catch((err) => {
          this.ShowAlertError(err.response && err.response.data || err.message || "Unable to load students.", '');
        })
        .finally(() => {
          this.onloader = "none";
        });
    },
    GetPortalRegisteredTerm() {
      let userdata = {
        SearchValue: null,
        PageNumber: 1,
        PageSize: 100
      }
      this.SessionIdval = 0;
      this.onloader = "flex";
      this.$store
        .dispatch("PortalSchoolSessionTerm/GetPortalRegisteredTerm", userdata)
        .then((resp) => {
          this.Sessionitems = resp.data;
          this.onloader = "none";
        })
        .catch((err) => {
          console.log(err);
          this.onloader = "none";
        });
    },
    GetSchoolClass() {
      this.$store
        .dispatch("getclass")
        .then((resp) => {
          this.SchoolClasses = resp;
        })
        .catch((err) => {
          this.ShowAlertError(err.response.data, '');
        });
    },
    submitSelectedStudents() {
      if (this.SessionIdval === 0) {
        this.ShowAlertError("Please select registered term", "");
        return;
      }
      if (this.cbtSubscribedVal === false && this.reportSubscribedVal === false) {
        this.ShowAlertError("You need to select subscription type", "");
        return;
      }
      if (this.SchoolStudents.length === 0) {
        this.ShowAlertError("Please select at least one student", "");
        return;
      }
       this.onloader = "flex";
      let registeredTermId = this.SessionIdval;
      let cbtSubscribed = this.cbtSubscribedVal;
      let reportSubscribed = this.reportSubscribedVal;
      let classNoteSubscribed = false;
      const studentIds = Array.isArray(this.SchoolStudents)
        ? this.SchoolStudents.map(s => s.studentId).join(',')
        : '';
      let paymentGateway = "Flutterwave";
      let userdata = {
        registeredTermId,
        cbtSubscribed,
        reportSubscribed,
        classNoteSubscribed,
        studentIds,
        paymentGateway
      };
      this.$store.dispatch("PortalStudentSubscription/InitiatePayment", userdata)
        .then(resp => {
          if (resp.responseCode != "00") {
            this.ShowAlertError(resp.responseMessage, "");
            this.onloader = "none";
            return;
          }
           this.onloader = "none";
          this.PaymentDetails = `You are to pay NGN${resp.data.details.amountPaid} via Paystack. Your payment reference is ${resp.data.details.transactionId}`;
          this.PaymentLink = resp.data.paymentLink;
          this.modals.PaymentModal = true;
        })
        .catch(err => {
          this.ShowAlertError(err.response && err.response.data || err.message || "Unable to start payment.", "");
        })
        .finally(() => {
          this.onloader = "none";
        });
    },
    MakePayment() {
      if (!this.PaymentLink) {
        this.ShowAlertError("Payment link not available", "");
        return;
      }
      const width = 500;
      const height = 700;
      const left = (window.innerWidth - width) / 2;
      const top = (window.innerHeight - height) / 2;
      window.open(
        this.PaymentLink,
        "PaymentPopup",
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
      );
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    } else {
      this.GetSchoolClass();
      this.GetPortalRegisteredTerm();
    }

  },
};
</script>
